require("./myProfileModifyConsentViewConfirm.scss");

// @ vendor
const React = require("react");
const PropTypes = require("prop-types");

// @ commons
const { formatText, FormattedText } = require("core/i18n").i18n;
const { OKLink } = require("commonsComponents/OKLink");
const { ContentBox } = require("commonsComponents/contentBox");
const IconSuccess = require("assets/images/icon-success.svg");
const IconError = require("assets/images/icon-error.svg");

const {
    retailLoanDoTaggin: { TAGGING_BACK },
    RETAIL_LOAN_CONSENTS_STATUS
} = require("ok-loans/src/loansConstants/index");

const {
    recordLinkV2,
    PROC_END
} = require("../../../../utilities/tagging");

class MyProfileModifyConsentViewConfirm extends React.Component {
    render() {
        const { 
            amazonStatus,
            errorMessage,
            hasError,
            interstitialStatus,
            pageNameBuilder,
        } = this.props;

        const InfoIcon = { icon: hasError ? IconError : IconSuccess };
        let interstitialMessage;
        let amazonMessage;

        if (interstitialStatus) {
            interstitialMessage = interstitialStatus === RETAIL_LOAN_CONSENTS_STATUS.ACCEPTED
                ? formatText(
                    "openMarketModifyConsentConfirm-openMarketModifyConsentConfirm_messageSuccessPositive"
                )
                : formatText(
                    "openMarketModifyConsentConfirm-openMarketModifyConsentConfirm_messageSuccessNegative"
                );
        }

        if (amazonStatus) {
            amazonMessage = amazonStatus === RETAIL_LOAN_CONSENTS_STATUS.ACCEPTED
                ? formatText(
                    "openMarketModifyConsentConfirm-openMarketModifyConsentConfirm_messageSuccessPositive"
                )
                : formatText(
                    "openMarketModifyConsentConfirm-openMarketModifyConsentConfirm_messageSuccessNegative"
                );
        }

        const titleMessage = hasError
            ? formatText(
                  "openMarketModifyConsentConfirm-openMarketModifyConsentConfirm_titleError"
              )
            : formatText(
                  "openMarketModifyConsentConfirm-openMarketModifyConsentConfirm_titleSuccess"
              );

        return (
            <div className="grid-view__body">
                <section className="container-fluid">
                    <div className="row grid-view--content-position-negative">
                        <ContentBox
                            customClassName="modify-consent-card"
                            title={titleMessage}
                            titleSeparator={true}
                            leftIcon={InfoIcon}
                        >
                            <div className="modify-consent-card__wrapper">
                                <div className="modify-consent-card__message">
                                    {hasError ? (
                                        <p className="modify-consent-card__message__info">
                                            {errorMessage}
                                        </p>
                                    ) : (
                                        <React.Fragment>
                                            {interstitialStatus && <React.Fragment>
                                                <p className="modify-consent-card__message__info">
                                                    <FormattedText value="openMarketModifyConsentConfirm-openMarketModifyConsentConfirm_messageSuccess" />
                                                </p>
                                                <span className="modify-consent-card__message__status">
                                                    {interstitialMessage}
                                                </span>
                                            </React.Fragment>
                                            }
                                            {amazonStatus && <React.Fragment> 
                                                <p className="modify-consent-card__message__info">
                                                    <FormattedText value="openMarketModifyConsentConfirm-openMarketModifyConsentConfirm_amazonMessageSuccess" />
                                                </p>
                                                <span className="modify-consent-card__message__status">
                                                    {amazonMessage}
                                                </span>
                                            </React.Fragment>
                                            }
                                        </React.Fragment>
                                    )}
                                </div>
                            </div>
                            <div className="ok-section-box__footer">
                                <footer className="wizard-step__buttons">
                                    <div className="wizard-step__third-button">
                                        <OKLink
                                            to={`/myprofile/edit/`}
                                            modifier="emphasize"
                                            extraClass="modify-consent-button"
                                            onClick={() => {
                                                if (!hasError) {
                                                    const buildData = {
                                                        categoriaEvento: pageNameBuilder(
                                                            PROC_END
                                                        ),
                                                        accionEvento: TAGGING_BACK,
                                                    };
                                                    recordLinkV2(buildData);
                                                }
                                            }}
                                        >
                                            <FormattedText value="openMarketModifyConsentConfirm-openMarketModifyConsentConfirm_buttonConfirmGoBack" />
                                        </OKLink>
                                    </div>
                                </footer>
                            </div>
                        </ContentBox>
                    </div>
                </section>
            </div>
        );
    }
}

MyProfileModifyConsentViewConfirm.propTypes = {
    amazonStatus: PropTypes.string.isRequired,
    errorMessage: PropTypes.string.isRequired,
    hasError: PropTypes.bool.isRequired,
    interstitialStatus: PropTypes.string.isRequired,
    pageNameBuilder: PropTypes.func.isRequired,
};

module.exports = MyProfileModifyConsentViewConfirm;
